import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import AboutSection from './components/AboutSection';
import PresentationsSection from './components/PresentationsSection';
import CatalogSection from './components/CatalogSection';
import WhyChooseSection from './components/WhyChooseSection';
import LocationsSection from './components/LocationsSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  useEffect(() => {
    const handleScrollReveal = () => {
      const elements = document.querySelectorAll('.scroll-reveal:not(.visible)');
      elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
          el.classList.add('visible');
        }
      });
    };

    window.addEventListener('scroll', handleScrollReveal, { passive: true });
    handleScrollReveal();

    return () => window.removeEventListener('scroll', handleScrollReveal);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <BenefitsSection />
        <AboutSection />
        <PresentationsSection />
        <CatalogSection />
        <WhyChooseSection />
        <LocationsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}